/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedSearchSuggestions_itemSearch$ref = any;
type SbSharedTitle_itemSearch$ref = any;
export type SbRespNullSearchResultsHeader_itemSearch$ref = any;
export type SbRespNullSearchResultsHeader_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedSearchSuggestions_itemSearch$ref & SbSharedTitle_itemSearch$ref;
    readonly " $refType": SbRespNullSearchResultsHeader_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResultsHeader_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'f76f46b72e2167eef75b5b994b1306b9';
export default node;
